import React, { useState, useEffect, useContext, useRef } from "react";
import "./NewArrival.css";
import { Card, Col, CardFooter, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";

import { Context } from "../../../utils/context";
import { Products } from "../../../utils/apis/Product/Product";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import DoubleHeading from "../../Common-Component/DoubleHeading/DoubleHeading";
library.add(fas);

const NewArrival = () => {
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  const { IMG_URL, setShimmerLoader } = useContext(Context);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const [products, setProducts] = useState([]);
  const getProduct = async () => {
    setShimmerLoader(true);
    const res = await Products("", "", "", "", "", "DESC");
    if (res?.success) {
      const currentDate = new Date();
      const twoDaysAgo = new Date();
      twoDaysAgo.setDate(currentDate.getDate() - 30);

      const filteredProducts = res.data.data.filter((product) => {
        const productDate = new Date(product.createdAt);
        return productDate >= twoDaysAgo;
      });

      setProducts(filteredProducts);
    }
    setShimmerLoader(false);
  };

  const [showAll, setShowAll] = useState(false);
  const [numToShow, setNumToShow] = useState();

  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    if (!swiperInstance) return;

    if (direction === "prev") {
      swiperInstance.slidePrev();
    } else {
      swiperInstance.slideNext();
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  if (products.length === 0) {
    return null;
  }

  return (
    <section className="NewArrival">
      <Container fluid>
        <div className="mb-4 mt-5">
          <DoubleHeading heading={"New Arrivals"} />
        </div>

        <div className="happy-cuto-sec">
          <Swiper
            spaceBetween={30}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            onSwiper={(swiper) => {
              setSwiperInstance(swiper);
            }}
            className="mySwiper"
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              420: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              486: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 5,
              },
            }}>
            {products.slice(0, numToShow).map((product, index) => {
              const price = product?.product_multiple_mains?.[0]
                ?.product_multiple_variants?.[0]?.mrp
                ? product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.mrp
                : product?.product_variants?.[0]?.mrp;

              const cutprice = product?.product_multiple_mains?.[0]
                ?.product_multiple_variants?.[0]?.cutting_price
                ? product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.cutting_price
                : product?.product_variants?.[0]?.cutting_price;
              return (
                <SwiperSlide key={index}>
                  <Product_Card
                    image={IMG_URL + product?.image1}
                    text={product?.name}
                    product_id={product?.id}
                    subText={product?.short_description}
                    price={price}
                    cutprice={cutprice}
                    newest={product?.newest}
                    variant_id={product?.product_variants?.[0]?.id}
                    m_variant_id={
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants[0]?.id
                    }
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div class="silder-btn">
            <div
              className="back-btn"
              onClick={() => handleMainSliderClick("prev")}></div>
            <div
              className="next-btn"
              onClick={() => handleMainSliderClick("next")}></div>
          </div>
        </div>

        {/* <div className="desktop_view_product_category_slider" ref={sectionRef}>
          <Row>
            {products.slice(0, numToShow).map((product, index) => {
              const price = product?.product_multiple_mains?.[0]
                ?.product_multiple_variants?.[0]?.mrp
                ? product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.mrp
                : product?.product_variants?.[0]?.mrp;

              const cutprice = product?.product_multiple_mains?.[0]
                ?.product_multiple_variants?.[0]?.cutting_price
                ? product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.cutting_price
                : product?.product_variants?.[0]?.cutting_price;
              return (
                <Col
                  key={index}
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={6}
                  sm={6}
                  className="custom_class_product">
                  <Product_Card
                    image={IMG_URL + product?.image1}
                    text={product?.name}
                    product_id={product?.id}
                    subText={product?.short_description}
                    price={price}
                    cutprice={cutprice}
                    newest={product?.newest}
                    variant_id={product?.product_variants?.[0]?.id}
                    m_variant_id={
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants[0]?.id
                    }
                  />
                </Col>
              );
            })}
          </Row>
        </div> */}

        {/* <div className="mobile_view_product_category_slider" ref={sectionRef}>
          <Row className="ms-0 me-0">
            {products.slice(0, numToShow).map((product, index) => {
              const price = product?.product_multiple_mains?.[0]
                ?.product_multiple_variants?.[0]?.mrp
                ? product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.mrp
                : product?.product_variants?.[0]?.mrp;

              const cutprice = product?.product_multiple_mains?.[0]
                ?.product_multiple_variants?.[0]?.cutting_price
                ? product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.cutting_price
                : product?.product_variants?.[0]?.cutting_price;

              return (
                <Col
                  key={index}
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={4}
                  sm={4}
                  xs={6}
                  className="custom_class_product">
                  <Product_Card
                    image={IMG_URL + product?.image1}
                    text={product?.name}
                    product_id={product?.id}
                    subText={product?.short_description}
                    price={price}
                    cutprice={cutprice}
                    newest={product?.newest}
                    variant_id={product?.product_variants?.[0]?.id}
                    m_variant_id={
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.id
                    }
                  />
                </Col>
              );
            })}
          </Row>
        </div> */}

        {/* {showAll ? (
          <div className="view-all mt-4" onClick={toggleShowAll}>
            <p>View Less</p>
          </div>
        ) : (
          products.length > 5 && (
            <div className="view-all mt-4" onClick={toggleShowAll}>
              <p>View All</p>
            </div>
          )
        )} */}

        {/* View All/ View Less Button */}
        {/* {products.length > 0 &&
          ((isMobile && numToShow > 0) ||
            (!isMobile && (numToShow < products.length || showAll))) && (
            <div className="view-all mb-5" onClick={toggleShowAll}>
              <p>
                {isMobile
                  ? numToShow >= products.length
                    ? "View Less"
                    : "View More"
                  : showAll
                  ? "View Less"
                  : "View All"}
              </p>
            </div>
          )} */}

        {products.length > 5 && (
          <div
            className="view-all mt-4"
            onClick={() => navigate("/select-from-category/27")}>
            <p>View All Products</p>
          </div>
        )}
      </Container>
    </section>
  );
};

export default NewArrival;

// export default NewArrival;
